(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["veyro-english-home"] && !Shopify.designMode) return;
  try {
    
function initVeyro(){
const image=document.getElementById('gallery-image');
const number=document.getElementById('gallery-number');
if(!image||!number)return;
const buttons=document.querySelectorAll('[data-view]');
buttons.forEach(button=>{if(button.dataset.bound)return;button.dataset.bound='true';button.addEventListener('click',()=>{image.src=button.querySelector('img').src;image.alt=button.dataset.alt;number.textContent=`0${Number(button.dataset.view)+1} / 02`;buttons.forEach(item=>{const active=item===button;item.classList.toggle('selected',active);item.setAttribute('aria-pressed',String(active));});});});
}
initVeyro();document.addEventListener('shopify:section:load',initVeyro);

  } catch(e) { console.error(e); }
})();
})();
